import EADialog from "components/common/EADialog";
import useStyles from "./EsgScoreModalStyle";
import ClassificationEsgScore from "./ClassificationEsgScore";
import i18next from "i18next";
import { convert } from "html-to-text";
import TopicExamplesTooltip from "./TopicExamplesTooltip";

const GovernanceScoreModal = ({dataESG, esgDetailsContent, isOpen, onClose}) => {
    const {classes} = useStyles();
    if(!esgDetailsContent) {
        return <></>
    }

    const formatThemeScore = (value) => {
        return value?.substring(value?.indexOf(":")+1, value?.length)
    }

    return (
        <EADialog isOpen={isOpen && esgDetailsContent} onClose={onClose} title={i18next.t("ESG.subjectGovernanceData")} maxWidth="lg" hasActions={false}>
            <div className={classes.gridColumns}>

                {dataESG?.governanceRankingScore &&
                    <div>
                        <div className={classes.subTitle}>{esgDetailsContent["classification_title"]}</div>
                        <ClassificationEsgScore esgDetailsContent={esgDetailsContent} score={String(dataESG?.governanceRankingScore)} />
                    </div>
                }

                <div>
                    <div className={classes.subTitle}>{esgDetailsContent["depth_scores_title"]}</div>
                    <div className={classes.flex}>
                        <div className={classes.score_bold}>{esgDetailsContent["governance_depth"]}</div>
                        <div className={classes.depthDescription}>{convert(esgDetailsContent["g_data_depth_description"])}</div>
                    </div>

                </div>
            </div>

            <table className={classes.table_scores}>
                <thead>
                <tr className={classes.table_scores_header}>
                    <th>{i18next.t("ESG.theme")}</th>
                    <th>{esgDetailsContent["table_header_score"]}</th>
                    <th className={classes.topicWidth}>{i18next.t("ESG.topic")}</th>
                    <th>{esgDetailsContent["table_header_score"]}</th>
                    <th>{esgDetailsContent["table_header_description"]}</th>
                </tr>
                </thead>
                <tbody>
                    <tr className={classes.topBorder}> 
                        <td className={classes.content_bold}>
                            <div className={classes.table_scores_theme_label}>{esgDetailsContent["business_sustainability_theme_label"]}</div>
                        </td>
                        <td className={classes.rightBorder}>
                            <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["business_sustainability_theme_score"])}</div>
                        </td>
                        <td className={classes.content_bold}>{esgDetailsContent["business_sustainability_label"]}</td>
                        <td className={classes.topic_score}>{esgDetailsContent["business_sustainability_score"]}</td>
                        <td>{esgDetailsContent["business_sustainability_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["business_sustainability_examples"]}/></td>
                   </tr>
                    <tr className={classes.topBorder}>
                        <td className={classes.content_bold}>
                            <div className={classes.table_scores_theme_label}>{esgDetailsContent["corporate_behaviors_theme_label"]}</div>
                        </td>
                        <td className={classes.rightBorder}>
                            <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["corporate_behaviors_theme_score"])}</div>
                        </td>
                        <td className={classes.content_bold}>{esgDetailsContent["corporate_compliance_label"]}</td>
                        <td className={classes.topic_score}>{esgDetailsContent["corporate_compliance_score"]}</td>
                        <td>{esgDetailsContent["corporate_compliance_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["corporate_compliance_examples"]}/></td>
                    
                    </tr>
                    <tr>
                        <td></td>
                        <td className={classes.rightBorder}></td>
                        <td className={classes.content_bold}>{esgDetailsContent["governance_certifications_label"]}</td>
                        <td className={classes.topic_score}>{esgDetailsContent["governance_certifications_score"]}</td>
                        <td>{esgDetailsContent["governance_certifications_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["governance_certifications_examples"]}/></td>
                    </tr>
                    <tr className={classes.topBorder}> 
                        <td className={classes.content_bold}>
                            <div className={classes.table_scores_theme_label}>{esgDetailsContent["corporate_governance_theme_label"]}</div>
                        </td>
                        <td className={classes.rightBorder}>
                            <div className={classes.table_scores_theme_score}>{formatThemeScore(esgDetailsContent["corporate_governance_theme_score"])}</div>
                        </td>
                        <td className={classes.content_bold}>{esgDetailsContent["board_accountability_label"]}</td>
                        <td className={classes.topic_score}>{esgDetailsContent["board_accountability_score"]}</td>
                        <td>{esgDetailsContent["board_accountability_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["board_accountability_examples"]}/></td>
                    
                    </tr>
                    <tr>
                        <td></td>
                        <td className={classes.rightBorder}></td>
                        <td className={classes.content_bold}>{esgDetailsContent["business_ethics_label"]}</td>
                        <td className={classes.topic_score}>{esgDetailsContent["business_ethics_score"]}</td>
                        <td>{esgDetailsContent["business_ethics_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["business_ethics_examples"]}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td className={classes.rightBorder}></td>
                        <td className={classes.content_bold}>{esgDetailsContent["business_transparency_label"]}</td>
                        <td className={classes.topic_score}>{esgDetailsContent["business_transparency_score"]}</td>
                        <td>{esgDetailsContent["business_transparency_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["business_transparency_examples"]}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td className={classes.rightBorder}></td>
                        <td className={classes.content_bold}>{esgDetailsContent["shareholder_rights_label"]}</td>
                        <td className={classes.topic_score}>{esgDetailsContent["shareholder_rights_score"]}</td>
                        <td>{esgDetailsContent["shareholder_rights_description"]}<TopicExamplesTooltip title={esgDetailsContent["table_header_examples"]} content ={esgDetailsContent["shareholder_rights_examples"]}/></td>
                        </tr>
                </tbody>
                </table>

        </EADialog>
    )


}

export default GovernanceScoreModal;